<template>
	<a-row :gutter="16">
		<a-col :span="14">
			<h6 class="text-uppercase"><strong>MEDIA</strong></h6>
			<div class="card border-gray-1">
				<template>
					<post-image
						:src="post.image"
						style="display: block; margin-left: auto; margin-right: auto; max-width: 100%"
					/>
				</template>
			</div>
		</a-col>
		<a-col :span="10">
			<a-row>
				<a-col :span="24" class="mb-3">
					<h6 class="text-uppercase">
						<strong>HASHTAGS</strong>
					</h6>
					<template v-if="post.hashtag">
						<span
							v-for="(item, index) in post.hashtag
								? post.hashtag.split(',')
								: []"
							:key="index"
							class="badge text-blue text-uppercase bg-gray-1 font-size-12 mr-2"
						>
							{{ item }}
						</span>
					</template>
					<template v-else>
						<a-alert
							:show-icon="false"
							message="No info available"
							banner
							type="info"
						/>
					</template>
				</a-col>
				<a-col :span="24" class="mb-3">
					<h6 class="text-uppercase">
						<strong>MENTIONS</strong>
					</h6>
					<template v-if="post.mention">
						<span
							v-for="(item, index) in post.mention
								? post.mention.split(',')
								: []"
							:key="index"
							class="badge text-blue text-uppercase bg-gray-1 font-size-12 mr-2"
						>
							{{ item }}
						</span>
					</template>
					<template v-else>
						<a-alert
							:show-icon="false"
							message="No info available"
							banner
							type="info"
						/>
					</template>
				</a-col>
				<a-col :span="24" class="mb-3">
					<h6 class="text-uppercase">
						<strong>CONTENT</strong>
					</h6>
					<template v-if="post.content">
						{{ postContent }}
					</template>
					<template v-else>
						<a-alert
							:show-icon="false"
							message="No info available"
							banner
							type="info"
						/>
					</template>
				</a-col>
				<a-col :span="24" class="mb-3">
					<h6 class="text-uppercase">
						<strong>CATEGORIES</strong>
					</h6>
					<post-category :post="post" />
				</a-col>
			</a-row>
		</a-col>
	</a-row>
</template>

<script>
import PostImage from '@/components/widgets/Image'
// import PostVideo from '@/components/widgets/Video'
import PostCategory from '@/components/widgets/Post/Category'
export default {
	name: 'PostInfo',
	components: {
		PostImage,
		// PostVideo,
		PostCategory,
	},
	props: {
		post: {
			type: Object,
			required: true,
		},
	},
	data: function() {
		return {
			postContent: '',
		}
	},
	created() {
		const decoded = this.post.content
			.replace(/\\u(....)/g, (match, p1) =>
				String.fromCharCode(parseInt(p1, 16)),
			)
			.replace(/\\(\d{3})/g, (match, p1) =>
				String.fromCharCode(parseInt(p1, 8)),
			)
		this.postContent = decoded.replace(/[\r\n]+/gm, '')
	},
}
</script>

<style></style>
